import RcInstanceDTO from '@robocorp/robocloud-internal-cds-sdk/lib/sdk/Types';
import { dashboardUserApi } from '~/utils/api';

export const getAll = async () =>
  dashboardUserApi.get<RcInstanceDTO.Organization[]>('/organizations');

export const getOneByShortName = async (shortName: string) =>
  dashboardUserApi.get<RcInstanceDTO.Organization>(`/organizationByShortName/${shortName}`);

export const getOrganizationInviteByToken = async (token: string) =>
  dashboardUserApi.get<RcInstanceDTO.OrganizationInviteWithOrganization>(
    `/organizations/invites/${token}`,
  );

export const getUserOrganizationInvites = async ({ realmId }: { realmId?: string }) =>
  dashboardUserApi.get<RcInstanceDTO.OrganizationInviteWithOrganization[]>(
    `/organizations/invites`,
    realmId !== undefined
      ? {
          realmId,
        }
      : undefined,
  );

export const acceptOrganizationInvite = async (token: string) =>
  dashboardUserApi.post<string>(`/organizations/invites/${token}`);

export const declineOrganizationInvite = async (token: string) =>
  dashboardUserApi.delete<string>(`/organizations/invites/${token}`);

export const create = async (
  name: string,
  email: string,
  mainBusiness?: string,
  teamCount?: string,
  purpose?: string,
) =>
  dashboardUserApi.post<RcInstanceDTO.Organization>('/organizations', {
    name,
    email,
    short_name: '',
    mainBusiness,
    teamCount,
    purpose,
  });
